import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { TabNav, TabNavItem } from 'src/components/CustomersBar/CustomerTab/BankingTab/BankingTabItems.style';

type TransactionHistoryTabItemsRouteType = 'deposit' | 'withdrawal' | 'manual-adjustment' | 'freebet-procedure';

const useHiddenStaffPaymentTabs = (): Array<string> => {
    const { staffCardDepositsEnabled, staffCardWithdrawalsEnabled } = ConfigState.get(useCommon()).config;

    const hiddenTabs: Array<string> = [];

    if (!staffCardDepositsEnabled) {
        hiddenTabs.push('deposit');
    }

    if (!staffCardWithdrawalsEnabled) {
        hiddenTabs.push('withdrawal');
    }

    return hiddenTabs;
};

export const BankingTabItems = observer((): JSX.Element | null => {
    const { routerBackoffice } = useAppStateContext();
    const hiddenTabs = useHiddenStaffPaymentTabs();
    const customerParams = useBankingTabParams();

    const isTabActive = (label: string): boolean => {
        return customerParams === label;
    };

    interface MenuItemType {
        id: TransactionHistoryTabItemsRouteType;
        label: string;
        onClick: () => void;
    }

    const menuItems: Array<MenuItemType> = [
        {
            id: 'deposit',
            label: 'Deposit',
            onClick: (): void => routerBackoffice.redirectToCustomerBankingDeposit(),
        },
        {
            id: 'withdrawal',
            label: 'Withdrawal',
            onClick: (): void => routerBackoffice.redirectToCustomerBankingWithdrawal(),
        },
        {
            id: 'manual-adjustment',
            label: 'Manual adjustment',
            onClick: (): void => routerBackoffice.redirectToCustomerBankingManualAdjustment(),
        },
        {
            id: 'freebet-procedure',
            label: 'Free Bets',
            onClick: (): void => routerBackoffice.redirectToCustomerBankingFreebetProcedure(),
        },
    ];

    const visibleMenuItems = menuItems.filter((linkItem) => !hiddenTabs.includes(linkItem.id));

    return (
        <TabNav>
            {visibleMenuItems.map((linkItem) => (
                <TabNavItem
                    key={linkItem.id}
                    isActive={isTabActive(linkItem.id)}
                    onClick={linkItem.onClick}
                    data-test={`${linkItem.id}-tab`}
                >
                    {linkItem.label}
                </TabNavItem>
            ))}
        </TabNav>
    );
});

export const useBankingTabParams = (): string => {
    const { routerBackoffice } = useAppStateContext();
    const hiddenTabs = useHiddenStaffPaymentTabs();
    const customerParams = routerBackoffice.getParametersString('customers', 'tab.tab.tab') ?? 'deposit';

    if (hiddenTabs.includes(customerParams)) {
        return 'manual-adjustment';
    }

    return customerParams;
};
